import { useTranslation } from 'react-i18next';
import { CheckCircleTwoTone } from '@mui/icons-material';
import { Chip } from '@mui/material';

export function OperationIssues({ count }: { count: number }) {
  const { t } = useTranslation();
  if (count === 0) return <CheckCircleTwoTone color="success" />;
  return (
    <Chip
      size="small"
      color="warning"
      label={t('operationIssues.warn', { count })}
    />
  );
}
